import createFetchingHandlers from '../../../../../../utils/createFetchingHandlers';
import createListReducer from '../../../../../../utils/createListReducer';
import actionTypes from '../constants/actionTypes';
import updateObjectByPath from '../../../../../../utils/updateObjectByPath';

const {
  RECEIPT_RESET,
  RECEIPT_FETCH,
  RECEIPT_SUCCESS,
  RECEIPT_ERROR,
  RECEIPT_LINE_ADD_FETCH,
  RECEIPT_LINE_ADD_SUCCESS,
  RECEIPT_LINE_ADD_ERROR,
  RECEIPT_LINE_EDIT_FETCH,
  RECEIPT_LINE_EDIT_SUCCESS,
  RECEIPT_LINE_EDIT_ERROR,
  RECEIPT_LINE_REMOVE_FETCH,
  RECEIPT_LINE_REMOVE_SUCCESS,
  RECEIPT_LINE_REMOVE_ERROR,
} = actionTypes;

const initialState = {
  data: [],
  metadata: {},
};

const fetchingData = createFetchingHandlers([RECEIPT_FETCH, RECEIPT_SUCCESS, RECEIPT_ERROR], () => ['metadata', 'fetchingData']);
const getDataHandler = {
  [RECEIPT_SUCCESS]: (state, action) => {
    const outputState = { ...state };
    outputState.data = action?.payload?.lines?.map((line) => ({
      data: line,
      metadata: {},
    }));

    return outputState;
  },
};

const resetHandler = {
  [RECEIPT_RESET]: () => {
    return initialState;
  },
};

/*const addLineFetching = createFetchingHandlers([RECEIPT_LINE_ADD_FETCH, RECEIPT_LINE_ADD_SUCCESS, RECEIPT_LINE_ADD_ERROR], (state, action) => {
  return ['data', state.data.findIndex((item) => item.data.ID === action.payload.lineId), 'metadata', 'addLineFetching'];
});*/

const addLineHandler = {
  [RECEIPT_LINE_ADD_FETCH]: (state) => {
    const outputState = { ...state };
    outputState.metadata = {
      lineFetching: true,
    };
    return outputState;
  },
  [RECEIPT_LINE_ADD_ERROR]: (state, action) => {
    const outputState = { ...state };
    outputState.metadata = {
      lineFetching: false,
    };
    return outputState;
  },
  [RECEIPT_LINE_ADD_SUCCESS]: (state, action) => {
    const outputState = { ...state };
    outputState.data = [
      ...outputState.data,
      {
        data: action.payload.data,
        metadata: {},
      },
    ];
    return outputState;
  },
};

const updateLineFetching = createFetchingHandlers([RECEIPT_LINE_EDIT_FETCH, RECEIPT_LINE_EDIT_SUCCESS, RECEIPT_LINE_EDIT_ERROR], (state, action) => {
  return ['data', state.data.findIndex((item) => item.data.ID === action.payload.data.ID), 'metadata', 'updateLineFetching'];
});

const updateLineHandler = {
  [RECEIPT_LINE_EDIT_SUCCESS]: (state, action) => {
    let outputState = { ...state };
    const index = state.data.findIndex((item) => item.data.ID === action.payload.data.ID);
    if (index >= 0) {
      outputState = updateObjectByPath(outputState, ['data', index, 'data'], action.payload.data);
    }
    return outputState;
  },
};

const deleteLineFetching = createFetchingHandlers([RECEIPT_LINE_REMOVE_FETCH, null, RECEIPT_LINE_REMOVE_ERROR], (state, action) => {
  return ['data', state.data.findIndex((item) => item.data.ID === action.payload.lineId), 'metadata', 'deleteLineFetching'];
});

const deleteLineHandler = {
  [RECEIPT_LINE_REMOVE_SUCCESS]: (state, action) => {
    const outputState = { ...state };
    outputState.data = outputState.data.filter((item) => item.data.ID !== action.payload.lineId);
    return outputState;
  },
};

export default createListReducer(
  initialState,
  [fetchingData, resetHandler, getDataHandler, updateLineFetching, addLineHandler, updateLineHandler, deleteLineFetching, deleteLineHandler],
);
